import { useOutletContext } from "react-router-dom";
import { NextGenLayoutContext } from "~/components/ManifoldNextGenLayout";
import { Button } from "~/components/ui/button";
import { Switch } from "~/components/ui/switch";
import { SettingsRow } from "~/pages/manifold-nextgen/components/settings/SettingsRow";
import { SettingsSection } from "~/pages/manifold-nextgen/components/settings/SettingsSection";

/**
 * The profile's Appearance tab: how the app looks. The controls themselves live
 * on the layout, which hands them down through the profile shell's `Outlet`.
 */
export const ProfileAppearanceTab = () => {
  const { isDark, onToggleDark, onSwitchToClassic } = useOutletContext<NextGenLayoutContext>();

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6">
      <SettingsSection title="Appearance">
        <SettingsRow title="Dark mode" description="Use the dark color theme across Manifold.">
          <Switch checked={isDark} onCheckedChange={onToggleDark} aria-label="Dark mode" />
        </SettingsRow>
        {onSwitchToClassic && (
          <SettingsRow
            title="Classic look"
            description="Switch back to the previous Manifold interface."
          >
            <Button variant="outline" onClick={onSwitchToClassic}>
              Switch to classic look
            </Button>
          </SettingsRow>
        )}
      </SettingsSection>
    </div>
  );
};
